export function XYZtoRGB(X, Y, Z) {
    let r = 3.2406 * X - 1.5372 * Y - 0.4986 * Z
    let g = -0.9689 * X + 1.8758 * Y + 0.0415 * Z
    let b = 0.0557 * X - 0.204 * Y + 1.057 * Z
    r = gammaEncode(r)
    g = gammaEncode(g)
    b = gammaEncode(b)
    return {r: r, g: g, b: b}
}

function gammaEncode(c) {
    if (c <= 0.0031308) {
        return 12.92 * c
    } else {
        return 1.055 * Math.pow(c, 1 / 2.4) - 0.055
    }
}
